/*
 *
 * TransactionTime actions
 *
 */

import {
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  GET_TRANSACTION_COMPLETE_TIME,
  SET_TRANSACTION_COMPLETE_TIME,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function setTransactionCompleteTimeAction(data) {
  return {
    type: SET_TRANSACTION_COMPLETE_TIME,
    data,
  };
}

export function getTransactionCompleteTimeAction(data) {
  return {
    type: GET_TRANSACTION_COMPLETE_TIME,
    data,
  };
}
